import { Link } from 'react-router-dom';
import './NewsItem.css';
import { getFullDate } from '../../services/DateService.js';
import { useEffect } from 'react';

function NewsItem(props) {

  function notifyOnReady() {
    props.onReady(props.number);
  }

  function handleImageLoaded() {
    notifyOnReady()
  }

  function handleImageErrored() {
    notifyOnReady()
  }

  useEffect(() => {
      if (props.item.mainImg.includes("_empty")) {
        notifyOnReady()
      }
  });

  return (
    <div className="news-item">
      <Link className="news-item__link" to={`/news/${props.item.id}`}>
        <span className="news-item__date">{getFullDate(props.item.date)}</span>
        {!props.item.mainImg.includes("_empty") &&
          <img className="news-item__image" src={props.item.mainImg} onLoad={handleImageLoaded} onError={handleImageErrored} alt="" />
        }
        <h6 className="news-item__title">{props.item.title}</h6>
      </Link>
    </div>
  );
}

export default NewsItem;